module.exports = __webpack_public_path__ + "static/media/Title.87211de1.png";